import { Box } from '@chakra-ui/react'
import { ClockSkewBar } from '~/components/shared/ClockSkewBar'
import { useClockSkewCheck } from '~/hooks/useClockSkewCheck'

// Pre-login clock-skew warning. Runs before auth so the user sees the likely
// cause up front — a skewed clock breaks the auth handshake, token validation,
// and (once shipped) time-based 2FA codes, none of which give an obvious
// reason on their own. Non-dismissible here on purpose (no onDismiss): it's the
// explanation for an otherwise inexplicable login failure.
export const ClockSkewNotice = () => {
  const { isClockSkewed } = useClockSkewCheck()

  if (!isClockSkewed) return null

  return (
    <Box position="absolute" top={0} left={0} right={0} zIndex={20}>
      <ClockSkewBar />
    </Box>
  )
}
